import View from './View';
import withAddUsers from './withAddUsers';

const AddUsers = withAddUsers(View);

export default AddUsers;
